import { articleSensitivityLayout } from 'utils/layoutUtils';
import {bannerAd, singleBottomMPUProps, topMPUProps, bottomMPUProps} from "../Common/components/GptProperties";

const leaderboardAd = {
  view: 'greyhounds'
};

const topMPU = {
  component: 'GooglePublisherTag',
  props: topMPUProps,
  desktopColumn: 'right',
  desktopOrder: 1,
  handheldOrder: false
};

const bottomMPU = {
  component: 'GooglePublisherTag',
  props: bottomMPUProps,
  desktopColumn: 'right',
  desktopOrder: 8,
  handheldOrder: false
};

const advertMPU = {
  component: 'AdvertWrapper',
  props: {
    ocSlot: ["greyhounds", "mpu"],
    additionalProperties: {
      view: 'greyhounds'
    }
  },
  desktopColumn: 'right',
  desktopOrder: 2,
  handheldOrder: false
};

const mostRead = {
  component: "MostReadAll",
  desktopColumn: "right",
  desktopOrder: 1,
  handheldOrder: 3
};

const greyhoundRHSComponents = [
  {
    component: 'RacingTips',
    props: {
      plainTitle: true
    },
    desktopColumn: 'right',
    desktopOrder: 4,
    handheldOrder: false
  },
  {
    component: 'HorseRacingNextRaceOff',
    props: {
      plainTitle: true
    },
    desktopColumn: 'right',
    desktopOrder: 5,
    handheldOrder: false
  },
  {
    component: 'FootballTips',
    props: {
      plainTitle: true
    },
    desktopColumn: 'right',
    desktopOrder: 7,
    handheldOrder: false
  }
];

const withAdverts = (...components) => ({
  bannerAd,
  leaderboardAd,
  components: [topMPU, advertMPU, bottomMPU, ...components, ...greyhoundRHSComponents]
});

const withAdvertsAndMostRead = (...components) => ({
  bannerAd,
  leaderboardAd,
  components: [mostRead, topMPU, advertMPU, bottomMPU, ...components, ...greyhoundRHSComponents]
});

const withAdvertsArticle = (...components) => ({
  leaderboardAd,
  components: [mostRead, topMPU, advertMPU, bottomMPU, ...components, ...greyhoundRHSComponents]
});

const withoutAdvertsArticle = (...components) => ({
  components: [mostRead, ...components, ...greyhoundRHSComponents]
});

const greyhoundRacingHomePageLayout = withAdvertsAndMostRead({
  component: 'MoreNews',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
},
{
  component: 'GptAdvert',
  props: {
    ocDetails: {
      ocSlot: ['greyhounds', 'leaderboard']
    },
    performDetails: singleBottomMPUProps
  },
  desktopColumn: 'left',
  desktopOrder: 2,
  handheldOrder: 2
});

const greyhoundRacingRacecardsLayout = withAdverts({
  component: 'GreyhoundRacingRacecardsForDateContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

const greyhoundRacingRaceLayout = withAdverts({
  component: 'GreyhoundRacingRacePageContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

const greyhoundRacingResultsLayout = withAdverts({
  component: 'GreyhoundRacingResultsForDateContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

const greyhoundRacingFastResultsLayout = withAdverts({
  component: 'GreyhoundRacingFastResults',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

const article = {
  component: 'Article',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
};
const greyhoundArticleLayout = withAdvertsArticle(article);
const greyhoundArticleSensitiveLayout = withoutAdvertsArticle(article);

export default {
  '/greyhounds': greyhoundRacingHomePageLayout,
  '/greyhounds/racecards': greyhoundRacingRacecardsLayout,
  '/greyhounds/racecards/:date/:courseSlug': greyhoundRacingRaceLayout,
  '/greyhounds/racecards/:date/:courseSlug/racecard/:raceId': greyhoundRacingRaceLayout,
  '/greyhounds/fast-results': greyhoundRacingFastResultsLayout,
  '/greyhounds/results': greyhoundRacingResultsLayout,
  '/greyhounds/results/:date': greyhoundRacingResultsLayout,
  '/greyhounds/news/:title/:articleId': layout => articleSensitivityLayout(layout, greyhoundArticleLayout, greyhoundArticleSensitiveLayout)
};



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/layouts.js